import { AvailableModules } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { locale } from 'modules/marketplace_modules/components/utils/locales'

import { useGetDatoModules } from './useGetDatoModules'

export const useGetChargebeeModuleId = (module?: AvailableModules | 'benefits' | 'datev') => {
  const { access } = useCurrentSession()
  const datoFormatLocale = locale[access.locale]
  const { loading, data } = useGetDatoModules({
    locale: datoFormatLocale,
    ...(module ? { chargebeeModuleName: module.toString() } : {}),
  })

  return { loading, id: data[0]?.chargebeeModuleId?.split(',')?.[0] }
}
